import { render } from "./BrandLoader.vue?vue&type=template&id=b7908138&scoped=true"
import script from "./BrandLoader.vue?vue&type=script&lang=js"
export * from "./BrandLoader.vue?vue&type=script&lang=js"

import "./BrandLoader.vue?vue&type=style&index=0&id=b7908138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7908138"]])

export default __exports__